import { Category } from 'containers/GamesBlock/types'

import { useGamesWithCategories } from './useGamesWithCategories'

export default function useSelectedCategory(select: (categories: Category[]) => Category | undefined) {
  return useGamesWithCategories({ select: ({ categories }) => select(categories) })
}
